import React from 'react';
import { PageHero } from '../components/PageHero';
export function PrivacyPolicyPage() {
  return <>
      <PageHero title="Privacy Policy" data-id="element-1050" />
      <section className="bg-white py-24" data-id="element-1051">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 prose prose-lg text-steel-600" data-id="element-1052">
          <p data-id="element-1053">Last updated: February 2025</p>
          <p data-id="element-1054">
            Chiltern Global Ltd ("we", "us", or "our") is committed to
            protecting and respecting your privacy. This policy sets out the
            basis on which any personal data we collect from you, or that you
            provide to us, will be processed by us.
          </p>
          <h3 data-id="element-1055">Information We Collect</h3>
          <p data-id="element-1056">We may collect and process the following data about you:</p>
          <ul data-id="element-1057">
            <li data-id="element-1058">
              Information you give us by filling in forms on our site (e.g.
              contact forms, catalogue requests).
            </li>
            <li data-id="element-1059">
              If you contact us, we may keep a record of that correspondence.
            </li>
            <li data-id="element-1060">
              Details of your visits to our site and the resources that you
              access.
            </li>
          </ul>
          <h3 data-id="element-1061">How We Use Your Information</h3>
          <p data-id="element-1062">We use information held about you in the following ways:</p>
          <ul data-id="element-1063">
            <li data-id="element-1064">
              To ensure that content from our site is presented in the most
              effective manner for you and for your computer.
            </li>
            <li data-id="element-1065">
              To provide you with information, products or services that you
              request from us.
            </li>
            <li data-id="element-1066">
              To carry out our obligations arising from any contracts entered
              into between you and us.
            </li>
          </ul>
          <h3 data-id="element-1067">Data Security</h3>
          <p data-id="element-1068">
            We take appropriate measures to ensure that your data is treated
            securely and in accordance with this privacy policy. Unfortunately,
            the transmission of information via the internet is not completely
            secure. Although we will do our best to protect your personal data,
            we cannot guarantee the security of your data transmitted to our
            site.
          </p>
          <h3 data-id="element-1069">Contact</h3>
          <p data-id="element-1070">
            Questions, comments and requests regarding this privacy policy are
            welcomed and should be addressed to enquiries@chilternglobal.com.
          </p>
        </div>
      </section>
    </>;
}